export default __webpack_public_path__ + "static/media/weige.9432cc86.jpg";